import { Lock } from 'lucide-react'
import { openSupportDock } from '@/components/support-dock'
import { Button } from 'tailwind-v4/components/button'
interface SubscriptionRequiredNoticeProps {
  /** Stampede-staff-only escape hatch (`subscriptionLockoutOverride` flag) to
   *  see the app underneath anyway, e.g. to debug/support the org. Omit the
   *  button entirely for everyone else. */
  canOverride?: boolean
  onOverride?: () => void
}

/**
 * Full-screen replacement for the org outlet when an organisation has no
 * subscription record at all (the public subscription lookup 404s). Mirrors
 * `NoVenueAccess` in `src/access/venue-guard.tsx` — same "you can't be here"
 * shape, different cause and action.
 */
export function SubscriptionRequiredNotice({
  canOverride,
  onOverride,
}: SubscriptionRequiredNoticeProps) {
  return (
    <div className="flex h-full w-full flex-1 items-center justify-center bg-background p-8 text-foreground">
      <div className="flex w-full max-w-md flex-col items-center gap-6 text-center">
        <div className="flex flex-col items-center gap-2">
          <Lock aria-hidden className="size-6 text-muted-foreground" />
          <h1 className="text-lg font-semibold">Subscription required</h1>
          <p className="text-sm text-muted-foreground">
            This organisation doesn&apos;t have an active subscription. Contact
            support to get set up.
          </p>
        </div>
        <div className="flex items-center gap-2">
          {canOverride && (
            <Button type="button" variant="outline" onClick={onOverride}>
              Stampede override
            </Button>
          )}
          <Button
            type="button"
            variant="primary"
            onClick={() => openSupportDock()}
          >
            Contact support
          </Button>
        </div>
      </div>
    </div>
  )
}
